module.exports = __webpack_public_path__ + "static/media/frequency.45749727.png";